import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Order2Cash from "../../assets/solutions/order2cash.png";
import B2B from "../../assets/solutions/B2B.png";
import Record2Report from "../../assets/solutions/record2report.png";
import CashManagement from "../../assets/solutions/CashMenagement.png";
import AccountPayable from "../../assets/solutions/AccountPayable.png";
import { useLanguage } from "../../i18n/LanguageContext";

const Solutions = () => {
  const { hash } = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [hash]);

  return (
    <div className="mt-[65px] lg:mt-[80px] min-h-screen pb-20 md:pb-0 bg-white">
      <div className="mx-auto sm:max-w-3xl lg:max-w-screen-2xl 2xl:max-w-screen-2xl px-5 md:px-8">
        <div className="w-full text-center pt-16 pb-4">
          <p className="text-sm md:text-base font-semibold uppercase tracking-widest text-orange mb-3">
            {t("solutions.label")}
          </p>
          <h1 className="text-blue text-3xl md:text-4xl lg:text-5xl font-bold">
            {t("solutions.title")}
          </h1>
          <div className="mt-4 mx-auto w-20 h-1 rounded-full bg-gradient-to-r from-orange to-pink" />
        </div>

        <div id="b2b-payments" className="mt-8 lg:mt-12 scroll-mt-24">
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-8 mt-10 items-center">
            <div>
              <h3 className="text-2xl lg:text-3xl text-blue font-bold">
                {t("solutions.b2b.title")}
              </h3>
              <div className="mt-4 space-y-4 text-base md:text-lg text-darkBlue/70 leading-relaxed">
                <p>{t("solutions.b2b.p1")}</p>
                <p>{t("solutions.b2b.p2")}</p>
                <p>{t("solutions.b2b.p3")}</p>
              </div>
            </div>
            <div className="overflow-hidden rounded-2xl shadow-lg shadow-blue/10 transition-all duration-500 hover:shadow-xl hover:-translate-y-1">
              <img alt="B2B Payments" src={B2B} className="w-full h-full object-cover" />
            </div>
          </div>
        </div>

        <div id="order-to-cash" className="mt-12 lg:mt-20 scroll-mt-24">
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-8 items-center">
            <div className="overflow-hidden rounded-2xl shadow-lg shadow-blue/10 transition-all duration-500 hover:shadow-xl hover:-translate-y-1 order-2 lg:order-1">
              <img alt="Order to Cash" src={Order2Cash} className="w-full h-full object-cover" />
            </div>
            <div className="order-1 lg:order-2">
              <h3 className="text-2xl lg:text-3xl text-blue font-bold">
                {t("solutions.orderToCash.title")}
              </h3>
              <p className="text-sm md:text-base text-darkBlue/50 mt-1">
                {t("solutions.orderToCash.subtitle")}
              </p>
              <div className="mt-4 space-y-4 text-base md:text-lg text-darkBlue/70 leading-relaxed">
                <p>{t("solutions.orderToCash.p1")}</p>
                <p>{t("solutions.orderToCash.p2")}</p>
              </div>
            </div>
          </div>
        </div>

        <div id="record-to-report" className="mt-12 lg:mt-20 scroll-mt-24">
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-8 items-center">
            <div>
              <h3 className="text-2xl lg:text-3xl text-blue font-bold">
                {t("solutions.recordToReport.title")}
              </h3>
              <p className="text-sm md:text-base text-darkBlue/50 mt-1">
                {t("solutions.recordToReport.subtitle")}
              </p>
              <div className="mt-4 space-y-4 text-base md:text-lg text-darkBlue/70 leading-relaxed">
                <p>{t("solutions.recordToReport.p1")}</p>
                <p>{t("solutions.recordToReport.p2")}</p>
                <p>{t("solutions.recordToReport.p3")}</p>
              </div>
            </div>
            <div className="overflow-hidden rounded-2xl shadow-lg shadow-blue/10 transition-all duration-500 hover:shadow-xl hover:-translate-y-1">
              <img alt="Record to Report" src={Record2Report} className="w-full h-full object-cover" />
            </div>
          </div>
        </div>

        <div id="cash-management" className="mt-12 lg:mt-20 scroll-mt-24">
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-8 items-center">
            <div className="overflow-hidden rounded-2xl shadow-lg shadow-blue/10 transition-all duration-500 hover:shadow-xl hover:-translate-y-1 order-2 lg:order-1">
              <img alt="Cash Management" src={CashManagement} className="w-full h-full object-cover" />
            </div>
            <div className="order-1 lg:order-2">
              <h3 className="text-2xl lg:text-3xl text-blue font-bold">
                {t("solutions.cashManagement.title")}
              </h3>
              <p className="text-sm md:text-base text-darkBlue/50 mt-1">
                {t("solutions.cashManagement.subtitle")}
              </p>
              <div className="mt-4 space-y-4 text-base md:text-lg text-darkBlue/70 leading-relaxed">
                <p>{t("solutions.cashManagement.p1")}</p>
                <p>{t("solutions.cashManagement.p2")}</p>
              </div>
            </div>
          </div>
        </div>

        <div id="account-payables" className="mt-12 lg:mt-20 mb-10 scroll-mt-24">
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-8 items-center">
            <div>
              <h3 className="text-2xl lg:text-3xl text-blue font-bold">
                {t("solutions.accountPayables.title")}
              </h3>
              <div className="mt-4 space-y-4 text-base md:text-lg text-darkBlue/70 leading-relaxed">
                <p>{t("solutions.accountPayables.p1")}</p>
              </div>
            </div>
            <div className="overflow-hidden rounded-2xl shadow-lg shadow-blue/10 transition-all duration-500 hover:shadow-xl hover:-translate-y-1">
              <img alt="Account Payables" src={AccountPayable} className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Solutions;
